import React, {createContext, useReducer} from 'react'

export const SET_USER_LIST = 'SET_USER_LIST'
export const SELECT_USER = 'SELECT_USER'
export const SET_SHOW_USER_POPUP = 'SET_SHOW_USER_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_USER_LIST:
      return { ...data, user_list: payload.data }
    case SELECT_USER:
      return {
        ...data,
        selected_user: payload.data.selected_user,
        show_user_popup: payload.data.show_user_popup,
      }
    case SET_SHOW_USER_POPUP:
      return {
        ...data,
        show_user_popup: payload.data,
        selected_user: payload.data ? data.selected_user : {},
      }
    default:
      return data
  }
}

const initialState = {
  user_list: [],
  selected_user: {},
  show_user_popup: false,
}

const UserStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <UserContext.Provider value={[state, dispatch]}>
      {children}
    </UserContext.Provider>
  )
}

export const UserContext = createContext(initialState)
export default UserStore
